import { memo } from 'react';
import { Controller } from 'react-hook-form';
import { Heading, VStack } from '../../../../library';
import type { PriceProgramComparison as PriceProgramComparisonProps } from '../../../types/customStoryblokComponents';
import OverviewTable from './OverviewTable';
import PriceProgram from './PriceProgram';

const PriceProgramComparison = ({
    content,
    value,
    onChange,
}: {
    content: PriceProgramComparisonProps;
    value: string;
    onChange: (value: string) => void;
}) => {
    return (
        <VStack gap="huge">
            <VStack gap="large">
                {content.programs.map(program => (
                    <PriceProgram
                        key={program.value}
                        program={program}
                        attributes={content.attributes}
                    />
                ))}
            </VStack>
            <VStack gap="small">
                <Heading h2>{content.overviewLabel}</Heading>
                <VStack>
                    <OverviewTable
                        content={content}
                        value={value}
                        onChange={onChange}
                    />
                </VStack>
                <div />
            </VStack>
        </VStack>
    );
};

const FormPriceProgramComparison = memo(
    (props: PriceProgramComparisonProps) => {
        return (
            <Controller
                name={props.name || props._uid}
                render={({ field }) => (
                    <PriceProgramComparison
                        content={props}
                        onChange={value => {
                            field.onChange(value);
                        }}
                        value={field.value}
                    />
                )}
                rules={{ required: true }}
            />
        );
    }
);

export default memo(FormPriceProgramComparison);
